import {
  dispatchAction,
  startTutorial,
  stopTutorial,
} from "@/components/tutorials/runner/TutorialRunner.js";

const TutorialRunnerPlugin = {
  install(Vue, options = {}) {
    const router = options.router;

    Vue.prototype.$tutorials = {
      start(steps = [], runnerOptions = {}) {
        return startTutorial(steps, {
          router,
          ...runnerOptions,
        });
      },

      stop() {
        return stopTutorial();
      },

      dispatch(action, payload, origin) {
        return dispatchAction(action, payload, origin);
      },
    };
  },
};

export default TutorialRunnerPlugin;
